<template>
  <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2 wf-items-center wf-relative">
    <transition name="fade">
      <span v-show="copiedText" class="wf-absolute wf-right-0 wf-top-0 wf--mt-2 wf-text-xs wf-text-gray-700 wf-font-semibold wf-tracking-wide">copied</span>
    </transition>
    <span class="wf-font-light wf-lowercase wf-text-gray-500 wf-w-1/2 wf-text-xs wf-tracking-wide">Element ID</span>
    <input
      :value="parentId"
      type="text"
      readonly
      @click.prevent="copyParentId"
      class="wf-cursor-pointer wf-w-1/2 wf-text-right focus:wf-bg-gray-300 wf-text-xs wf-bg-gray-300 wf-text-gray-700 wf-border wf-rounded focus:wf-outline-none wf-px-2 wf-py-1"
    />
  </li>
</template>

<script>
  export default {
    props: {
      element: {
        type: Object,
        required: true,
      }
    },
    data() {
      return {
        copiedText: false
      }
    },
    computed: {
      elementSidebar() {
        return this.$store.getters['settingsModule/elementSidebar']
      },
      parent() {
        if (! this.elementSidebar) {
          return this.$parent.$parent  
        }
        return this.$parent
      },
      parentId() {
        return this.parent.id
      },
      module() {
        return this.parent.module
      }
    },
    methods: {
      copyParentId(e) {
        e.target.select()
        document.execCommand('copy')
        this.copiedText = true
        if (window.getSelection) {
          window.getSelection().removeAllRanges()
        }
        if (document.selection) {
          document.selection.empty()
        }
        window.setTimeout(() => this.copiedText = false, 1000)
      }
    }
  }
</script>

<style>
  .fade-enter-active, .fade-leave-active {
    transition: all .2s;
  }
  .fade-enter {
    opacity: 0;
    transform: translateY(.75rem);
  }
  .fade-leave-to  {
    opacity: 0;
  }
</style>